import { render, staticRenderFns } from "./WalletChooseDialog.vue?vue&type=template&id=0bccd424&scoped=true"
import script from "./WalletChooseDialog.vue?vue&type=script&lang=js"
export * from "./WalletChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletChooseDialog.vue?vue&type=style&index=0&id=0bccd424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccd424",
  null
  
)

export default component.exports